interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  actionText?: string;
  actionHref?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  actionText,
  actionHref = "#top",
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-8 md:mb-12">
      <div className="max-w-2xl">
        <div className="flex items-center gap-2 mb-3">
          <span className="w-6 h-px bg-primary-500" />
          <span className="text-xs md:text-sm tracking-[0.28em] text-primary-700 font-label uppercase">
            {eyebrow}
          </span>
        </div>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
          {title}
        </h2>
        {desc ? (
          <p className="mt-3 md:mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            {desc}
          </p>
        ) : null}
      </div>
      {actionText ? (
        <a
          href={actionHref}
          className="group inline-flex items-center gap-2 self-start md:self-auto whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-label text-foreground-800 transition-colors duration-300 hover:border-primary-300 hover:text-primary-700 cursor-pointer"
        >
          {actionText}
          <i className="ri-arrow-right-line text-base transition-transform duration-300 group-hover:translate-x-1" />
        </a>
      ) : null}
    </div>
  );
}